import axios from 'axios';

// 환경에 따른 API baseURL 설정
const getApiBaseUrl = () => {
  // 프로덕션 환경
  if (process.env.NODE_ENV === 'production') {
    // api.visuallab.kr이 Hosting에 연결된 경우
    // firebase.json의 rewrites 설정에 따라 /api로 시작하는 경로는 자동으로 Functions로 라우팅됨
    // 따라서 상대 경로를 사용하면 됨
    return '';
  }
  
  // 개발 환경에서는 상대 경로 사용 (vue.config.js의 proxy 설정 활용)
  return '';
};

// axios 인스턴스 생성
const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 요청 인터셉터: 에러 처리 및 디버깅
api.interceptors.request.use(
  (config) => {
    // 프로덕션 환경에서 요청 URL 로깅 (디버깅용)
    if (process.env.NODE_ENV === 'production') {
      console.log('API Request:', config.method?.toUpperCase(), config.url);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 응답 인터셉터: 에러 처리
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 404 에러 상세 정보 로깅
    if (error.response?.status === 404) {
      console.error('404 Error Details:', {
        url: error.config?.url,
        baseURL: error.config?.baseURL,
        fullURL: error.config?.baseURL + error.config?.url,
        hostname: window.location.hostname
      });
    }
    return Promise.reject(error);
  }
);

export default api;
